import { DocLink, DocLinkBlock } from '../../viz.types';

export const resolveDocLinks = (block: DocLinkBlock): DocLink[] => {
  if (block.links?.length) {
    return block.links;
  }

  return block.url ? [{ title: block.title, url: block.url }] : [];
};
